import ErrorCode from "./errorCode.js";
import Api from "./api.js";
import SaveAs from "file-saver";

export default {
  mixins: [ErrorCode],
  computed: {
    displayNumber: function () {
      return function (val) {
        if (val === null || val === "") {
          return "";
        } else if (isNaN(Number(val))) {
          return val;
        }

        return new Intl.NumberFormat("ja-JP").format(val);
      };
    },
    displayYen: function () {
      return function (val) {
        if (val === null || val === "") {
          return "";
        } else if (isNaN(Number(val))) {
          return val;
        }

        return new Intl.NumberFormat("ja-JP", {
          style: "currency",
          currency: "JPY",
        }).format(val);
      };
    },
  },
  methods: {
    dispNotFound() {
      this.$router.replace({ name: "NotFound" });
    },
    /*
     * パスワードリセット
     */
    sendResetPassword(user_id, funcOK, funcNG) {
      const url = this.getVoislogURL("password_reset");
      const sendData = {
        email: user_id,
      };
      Api.sendApi_1_1_Post(
        url,
        sendData,
        this.$root.userInfo.access_token,
        funcOK,
        funcNG,
      );
    },
    // Dialog
    initDialog(title, text, execOk, execCancel) {
      if (typeof val !== this.$root.$refs.commonDialog) {
        this.$root.$refs.commonDialog.initDialog(
          title,
          text,
          execOk,
          execCancel,
        );
      }
    },
    setDialogTitle(title) {
      if (typeof val !== this.$root.$refs.commonDialog) {
        this.$root.$refs.commonDialog.setDialogTitle(title);
      }
    },
    setDialogText(text) {
      if (typeof val !== this.$root.$refs.commonDialog) {
        this.$root.$refs.commonDialog.setDialogText(text);
      }
    },
    openDialog() {
      if (typeof val !== this.$root.$refs.commonDialog) {
        this.$root.$refs.commonDialog.open();
      }
    },

    // Snackbar
    initSnackbar() {
      if (typeof val !== this.$root.$refs.commonSnackbar) {
        this.$root.$refs.commonSnackbar.init();
      }
    },
    dispSuccess(msg) {
      if (typeof val !== this.$root.$refs.commonSnackbar) {
        this.$root.$refs.commonSnackbar.dispSuccess(msg);
      }
    },
    dispWarning(msg) {
      if (typeof val !== this.$root.$refs.commonSnackbar) {
        this.$root.$refs.commonSnackbar.dispWarning(msg);
      }
    },
    dispError(msg) {
      if (typeof val !== this.$root.$refs.commonSnackbar) {
        this.$root.$refs.commonSnackbar.dispError(msg);
      }
    },

    // Loading
    startLoading() {
      if (typeof val !== this.$root.$refs.commonLoading) {
        this.$root.$refs.commonLoading.start();
      }
    },
    stopLoading() {
      if (typeof val !== this.$root.$refs.commonLoading) {
        this.$root.$refs.commonLoading.stop();
      }
    },
    startLoading2() {
      if (typeof val !== this.$root.$refs.commonLoading2) {
        this.$root.$refs.commonLoading2.start();
      }
    },
    stopLoading2() {
      if (typeof val !== this.$root.$refs.commonLoading2) {
        this.$root.$refs.commonLoading2.stop();
      }
    },
    startLoadingLine() {
      if (typeof val !== this.$root.$refs.commonLoadingLine) {
        this.$root.$refs.commonLoadingLine.start();
      }
    },
    stopLoadingLine() {
      if (typeof val !== this.$root.$refs.commonLoadingLine) {
        this.$root.$refs.commonLoadingLine.stop();
      }
    },

    checkCommonError(e) {
      if (!e.response) {
        this.dispError(this.ERROR_CODES["E_COMM_999"]);
        return true;
      }
      if (e.response.status === 426) {
        window.alert(this.$t("label_reload_required"));
        window.location.reload();
        return true;
      }
      if (e.response.status >= 500) {
        this.dispError(this.ERROR_CODES["E_COMM_999"]);
        return true;
      } else {
        if (e.response.status == 401) {
          switch (e.response.data.detail.type) {
            case "auth_error.invalid_input": // ユーザーIDまたはパスワード誤り
              this.dispError(this.ERROR_CODES["E_LGIN_003"]);
              break;
            case "auth_error.unverified": // メール未認証
              this.dispError(this.$t("label_unverified_error"));
              break;
            case "auth_error.locked_temporary": // ユーザーが一時ロックされている
              this.dispError(this.ERROR_CODES["E_LGIN_008"]);
              break;
            case "auth_error.no_contract": // 契約なし
              this.dispError(this.ERROR_CODES["E_LGIN_006"]);
              break;
            case "auth_error.token_expired": // トークンの有効期限切れ
              this.dispError(this.ERROR_CODES["E_LGIN_007"]);
              break;
            case "auth_error.invalid_token": // トークン不正
              this.dispError(this.ERROR_CODES["E_LGIN_007"]);
              break;
            case "auth_error.invalid_google_credential": // SSOトークン不正
              this.dispError(this.ERROR_CODES["E_LGIN_009"]);
              break;
            case "auth_error.vmanagement_not_allowed": // vManagementへのログインが許可されていないロール
              this.dispError(this.ERROR_CODES["E_LGIN_010"]);
              break;
            default:
              this.dispError(this.ERROR_CODES["E_COMM_998"]);
              break;
          }
          return true;
        } else if (e.response.status == 403) {
          this.dispNotFound();
        } else if (e.response.status == 404) {
          this.dispNotFound();
        } else if (
          e.response.status == 422 &&
          e.response.config.method == "get"
        ) {
          // GETメソッドのときはNot Foundへ
          this.dispNotFound();
        }
      }
      return false;
    },
    display409ErrorMessage(e, paramNames = {}, defaultMessage = "") {
      if (
        typeof e.response.data?.detail === "undefined" ||
        e.response.data?.detail === null
      ) {
        this.dispError(defaultMessage);
        return;
      }

      //409エラー時、Duplicateエラーとなったkeyとvalueをエラーメッセージから検索
      const regex = /Key\s+\(([^)]+)\)=\(([^)]+)\)/;
      const match = e.response.data.detail.match(regex);
      if (match !== null && match[1] in paramNames) {
        this.dispError(
          this.$t("label_duplicate_error", {
            name: paramNames[match[1]],
          }),
        );
      } else {
        this.dispError(defaultMessage);
      }
    },
    /*
     * CSVファイル取得
     */
    getCsvFile(response, filenameDefault) {
      let filename = null;
      // responseのContent-Dispositionからファイル名取得
      if (typeof response.headers["content-disposition"] !== "undefined") {
        const contentDisposition = response.headers["content-disposition"];

        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/; // 正規表現でfilenameを抜き出す
        const matches = filenameRegex.exec(contentDisposition);
        if (matches != null && matches[1]) {
          filename = decodeURI(matches[1].replace(/['"]/g, ""));
        }
      }

      if (filename == null) {
        filename = filenameDefault;
      }

      const blob = new Blob([response.data], { type: response.data.type });
      SaveAs(blob, filename);
    },
    /*
     * 解析結果CSVファイル取得
     */
    getAnalysisResultCsvFile(response) {
      this.getCsvFile(response, "data.csv");
    },
    /*
     * CSVダウンロードエラーの共通処理
     * エンコードエラーの場合は専用メッセージを表示して true を返す
     * それ以外の場合は false を返す
     */
    handleCsvDownloadError(e) {
      if (e.response && e.response.status === 400) {
        const detail = e.response.data?.detail;
        if (
          detail &&
          typeof detail === "string" &&
          detail.includes("encode error")
        ) {
          this.dispError(this.ERROR_CODES["E_CSVE_001"]);
          return true;
        }
      }
      return false;
    },
    /*
     * パスワードCSVファイル取得
     */
    getPasswordCsvFile(response) {
      this.getCsvFile(response, "password.csv");
    },

    getTabHref(tab_name) {
      return `/#${this.$route.path}#${tab_name}`;
    },

    getUserIdParameter(user_type, user_id) {
      if (!user_id) {
        return;
      }
      return `${user_type}_id=${encodeURIComponent(user_id)}`;
    },
    mergeDeep(target, source) {
      for (const key in source) {
        if (source[key] instanceof Object) {
          if (!target[key]) Object.assign(target, { [key]: {} });
          this.mergeDeep(target[key], source[key]);
        } else {
          Object.assign(target, { [key]: source[key] });
        }
      }
    },
    roundValue(val, digit = 0) {
      return Math.round(val * 10 ** digit) / 10 ** digit;
    },
  },
};
